import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import UserCrudForm from './UserCrudForm';

export default function UserCrudDrawer(props) {
    const classes = useStyles();

    return (
        <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.closeDrawer()} transitionDuration={500}>
            <div className={classes.drawerBody}>
                <div className={classes.header}>
                    <div className={classes.title}>{props.create ? "Nieuwe gebruiker aanmaken" : "Gebruiker editeren"}</div>
                    <div className={classes.close}>
                        <Button className={classes.closeButton} onClick={() => props.closeDrawer()}>
                            <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                        </Button>
                    </div>
                </div>
                <UserCrudForm open={props.drawerOpen} closeDrawer = {props.closeDrawer} create = {props.create} roles = {props.roles} refresh = {props.refresh} userToEdit = {props.userToEdit}></UserCrudForm>
            </div>
        </Drawer>)
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "5px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "646px",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px"
    },
    header: {
        width: "100%",
        height: "5%",
        marginBottom: "20px"
    },
    body: {
        width: "100%",
        height: "95%"
    }

}));

